import {
    RouteLocationInterface,
    RouteHttpVerb,
    RouteResponseInterface,
    RouteRequestInterface,
    RouteParamsInterface
} from "@wpnotes/utils";
import { UserModel } from "../models";

export const locationRestUserGet: RouteLocationInterface = {
    path: "/user",
    method: RouteHttpVerb.GET
};

export type RequestRouteUserGet = RouteRequestInterface;

export type ParamsRouteUserGet = RouteParamsInterface;

export interface ResponseRouteUserGet extends RouteResponseInterface {
    data: UserModel[];
    errors: string[];
}
